import React from 'react';
import { useStores } from '../stores';
import UserBanner from './UserBanner';
import Tabs from './Tabs';
import { isPublicRoute } from '../utils/route';

const Header = () => {
  const { userStore } = useStores();
  const { isLogged } = userStore;

  return (
    <>
      {isLogged && !isPublicRoute() && (
        <>
          <UserBanner />
          <Tabs />
        </>
      )}
    </>
  );
};

export default Header;
